import React from "react";

import CsLineIcons from "../../cs-line-icons";

class Label extends React.Component {
    render() {
        let __icon = null;
        const __source = this.props.source ?? "line";

        if (this.props.icon) {
            if (__source === "css") {
                __icon = <i className={this.props.icon} style={{ paddingRight: ".4rem", color: this.props.iconColor ?? "inherited", fontSize: this.props.iconFontSize || "20px"}} />
            } else if (__source === "line") {
                __icon = <CsLineIcons icon={this.props.icon} className="cs-icon icon" style={{ paddingRight: "1px" }} />
            }
        }

        return (
            <>
                {__icon ?? ''} <span className="label" > {this.props.caption ?? ""}</span >
            </>
        )

    }
}

export default Label;